
import React from "react";
import "./Suggestion.css";
import { withRouter } from "react-router-dom";
import withSnackbar from "../../util/withSnackbar";
import { SNACKBAR_OPTIONS, TIMEOUT, DATE_FORMAT, YEAR_FORMAT } from '../../constants/CommonConstants';
import { injectIntl } from "react-intl";
import Header from "../CeHeader/Header";
import { LinearProgress } from '@mui/material';
import Button from '@mui/material/Button';
import _ from 'lodash';
import cognitoAuth from "../../util/Cognito";
import { errorHandle } from '../../Common/errorHandle';
import moment from 'moment';
import Checkbox from '@mui/material/Checkbox';

class Suggestion extends React.Component {
    constructor(props) {
        super(props);
        let targetYear = localStorage.getItem("suggestionYear") ?  localStorage.getItem("suggestionYear") : moment().format(YEAR_FORMAT) + '-01';
        this.changeTargetDate = this.changeTargetDate.bind(this);
        this.getWeeks = this.getWeeks.bind(this);
        this.goBack = this.goBack.bind(this);
        this.changeSuggestion = this.changeSuggestion.bind(this);
        this.editSuggestion = this.editSuggestion.bind(this);
        this.getYearList = this.getYearList.bind(this);
        this.getUserSuggestionList = this.getUserSuggestionList.bind(this);
        this.editBtnClassName = this.editBtnClassName.bind(this);

        let yearList = this.getYearList();

        this.state = {
            targetYear: targetYear,
            userId: new URLSearchParams(this.props.location.search).get('userId'),
            suggestionList: [],
            suggestionChangeBefore:[],
            successDisplay: 'none',
            isProgress: false,
            requestType: 0,
            yearList,

        }
    };

    componentDidMount() {
        this.getUserSuggestionList()
    }

    getUserSuggestionList() {
        let header = {
            'Authorization': ''
        };

        this.setState({ isProgress: true });
        cognitoAuth.getAuthorizationToken().then((token) => {
            header.Authorization = token;
        }, (error) => {
            this.setState({ isProgress: false });
            throw error;
        }).then(() => {
            const controller = new AbortController();
            const props = this;
            const timer = window.setTimeout(errorHandle(function () {
                controller.abort();
                throw props;
            }), TIMEOUT);
            let targetStartDate = moment(this.state.targetYear).startOf('year').format(DATE_FORMAT);
            let targetEndDate = moment(this.state.targetYear).endOf('year').format(DATE_FORMAT);
            let suggestQs = new URLSearchParams({
                userId: this.state.userId,
                targetStartDate,
                targetEndDate,
            });
            fetch(process.env.REACT_APP_CE_SUGGESTION + `?${suggestQs}`, {
                method: "GET",
                headers: header,
                signal: controller.signal,
            }).then(res => {
                window.clearTimeout(timer);
                if (res.ok) {
                    return res.json();
                }
            }).then(suggestionList => {
                if (suggestionList.length > 0) {
                    let suggestionCopyList = [...suggestionList]
                    suggestionCopyList.forEach(item => {
                        item['suggestionChange'] = ''
                        item['deleteChecked'] = false
                        item['generateChecked'] = false
                    })
                    this.setState({
                        suggestionList: suggestionCopyList,
                        suggestionChangeBefore:JSON.parse(JSON.stringify(suggestionCopyList)),
                        requestType: 1
                    })
                } else {
                    let weekList = this.getWeeks();
                    this.setState({
                        suggestionList: weekList,
                        suggestionChangeBefore: JSON.parse(JSON.stringify(weekList)),
                        requestType: 0
                    })
                }
            }).catch(() => {
                this.props.openSnackbar(this.props.intl.formatMessage({ id: "server_error" }));
            }).finally(() => {
                this.setState({ isProgress: false });
            });
        }).catch(() => {
            cognitoAuth.sessionTimeOut(this.props);
            this.setState({ isProgress: false });
        });
    }

    getYearList() {
        let year = moment().format(YEAR_FORMAT);
        let minYear = moment().add(-3, 'years').format(YEAR_FORMAT);
        let yearList = []
        for (let targetYear = minYear; targetYear <= year;) {
            yearList.push(targetYear + '');
            targetYear++;
        }
        yearList.reverse()
        return yearList;
    }

    changeTargetDate(e) {
        localStorage.setItem("suggestionYear", e);
        this.setState({
            targetYear: e
        }, () => {
            this.getUserSuggestionList();
        })
    }

    getWeeks() {
        let targetYear = this.state.targetYear;
        let yearStart = moment(targetYear).startOf('year').format(DATE_FORMAT);
        let yearEnd = moment(targetYear).endOf('year').format(DATE_FORMAT);
        let data = [];
        let d = moment(yearStart).startOf('week').format(DATE_FORMAT)
        if (moment(d).format(YEAR_FORMAT) !== moment(yearStart).format(YEAR_FORMAT)) {
            d = moment(d).add(1, 'week').format(DATE_FORMAT);
        }
        let to = moment(yearEnd).endOf('week').format(DATE_FORMAT)

        for (let from = d; from < to;) {
            let startDate = from;
            let endDate = '';
            if (from < to) {
                endDate = moment(from).add(6, 'days').format(DATE_FORMAT);
                from = moment(from).add(1, 'week').format(DATE_FORMAT);
            } else {
                endDate = to;
            }
            let obj = {
                startDate,
                endDate,
                suggestion: '',
                suggestionChange: '',
                deleteChecked: false,
                generateChecked: false,
            }
            data.push(obj)
        }
        return data;
    }

    goBack() {
        this.props.history.goBack();
    }

    editSuggestion() {
        let suggestionList = [...this.state.suggestionList];
        if (this.state.requestType !== 0) {
            suggestionList = suggestionList.filter((item) => !!item.suggestionChange || item.deleteChecked || item.generateChecked);
        }
        suggestionList.map(item => {
            if (!!item.suggestionChange) {
                item.suggestion = item.suggestionChange;
            }
            delete item.suggestionChange;
        })
        let header = {
            'Authorization': '',
            'Content-Type': 'application/json'
        };
        this.setState({ isProgress: true });
        cognitoAuth.getAuthorizationToken().then((token) => {
            header.Authorization = token;
        }, (error) => {
            this.setState({ isProgress: false });
            throw error;
        }).then(() => {
            const controller = new AbortController();
            const props = this;
            const timer = window.setTimeout(errorHandle(function () {
                controller.abort();
                throw props;
            }), TIMEOUT);
            let targetStartDate = moment(this.state.targetYear).startOf('year').format(DATE_FORMAT);
            let targetEndDate = moment(this.state.targetYear).endOf('year').format(DATE_FORMAT);
            fetch(process.env.REACT_APP_CE_EDIT_SUGGESTION, {
                method: "POST",
                headers: header,
                signal: controller.signal,
                body: JSON.stringify({
                    userId: this.state.userId,
                    targetStartDate,
                    targetEndDate,
                    suggestionList,
                })
            }).then(res => {
                window.clearTimeout(timer);
                this.setState({ isProgress: false });
                if (res.ok) {
                    document.location.reload();
                } else {
                    return res.json();
                }
            }).then((error) => {
                if (error) {
                    if (error.status === 400) {
                        this.props.openSnackbar(
                            this.props.intl.formatMessage({
                                id: "ce_error_400",
                            })
                        );
                        document.location.reload();
                    }
                }
            }).catch((e) => {
                cognitoAuth.sessionTimeOut(this.props);
                this.setState({ isProgress: false });
            });
        }).catch(() => {
            cognitoAuth.sessionTimeOut(this.props);
            this.setState({ isProgress: false });
        });
    }

    changeSuggestion(suggestion, index) {
        let suggestionList = this.state.suggestionList;
        suggestionList[index].suggestionChange = suggestion;
        
        this.setState({
            suggestionList: suggestionList,
        },()=>{
            this.editBtnClassName()
        })
    }

    editBtnClassName() {
        return _.isEqual(this.state.suggestionList, this.state.suggestionChangeBefore)
            ? "disabled button editbtn"
            : "button editbtn";
    }
    deletehandleChange(event) {
        let suggestionList = this.state.suggestionList
        suggestionList[event.index].deleteChecked = !suggestionList[event.index].deleteChecked
        this.setState({
            suggestionList : suggestionList
        })
    }

    generatehandleChange(event) {
        let suggestionList = this.state.suggestionList
        suggestionList[event.index].generateChecked = !suggestionList[event.index].generateChecked
        this.setState({
            suggestionList : suggestionList
        })
    }
    
    render() {
        return (
            <div id="ceSuggestion" className="body">
                {this.state.isProgress ? <LinearProgress /> : ''}
                <Header showSubMenu={true} />
                <div className="suggestion-body">
                    <div className="suggestion-content">
                        <div>
                            <div className="target_date">
                                <select id="yearSelect" className="yearSelect" defaultValue={this.state.targetYear} onChange={(e) =>
                                    this.changeTargetDate(
                                        e.target.value
                                    )
                                }>
                                    {this.state.yearList.map((yearParam) => (
                                        <option value={yearParam}>{yearParam}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className="basicInfo">
                            <div className="suggest-date">
                                <span>
                                    {this.props.intl.formatMessage({ id: "date" })}
                                </span>
                            </div>
                            <div className="before-suggest">
                                <span>
                                    {this.props.intl.formatMessage({ id: "before_suggistion" })}
                                </span>
                            </div>
                            <div className="after-suggest">
                                <span>
                                    {this.props.intl.formatMessage({ id: "after_suggestion" })}
                                </span>
                            </div>
                            <div className="delete-suggest">
                                <span>
                                    {this.props.intl.formatMessage({ id: "delete_suggestion" })}
                                </span>
                            </div>
                            <div className="generate-suggest">
                                <span>
                                    {this.props.intl.formatMessage({ id: "generate_suggestion" })}
                                </span>
                            </div>
                        </div>
                        <div className="suggest_detail">
                            {this.state.suggestionList.length > 0 ? this.state.suggestionList.map((suggestion, index) => (
                                <div className="basicInfo-detail">
                                    <div className="suggest-date">
                                        <input type="text" className="suggest-date-input" name="suggestionDate" value={suggestion.startDate + ' ~ ' + suggestion.endDate} disabled />
                                    </div>
                                    <div className="before-suggest">
                                        <input type="text" name="suggestion" value={suggestion.suggestion} size="45" title={suggestion.suggestion} disabled />
                                    </div>
                                    <div className="after-suggest">
                                        <input type="text" name="suggestionChange" value={suggestion.suggestionChange} size="50" onChange={event => this.changeSuggestion(event.target.value, index)} maxLength="100" />
                                    </div>
                                    <div className="delete-suggest">
                                        <Checkbox
                                            className="deleteChecked"
                                            Checked={suggestion.deleteChecked}
                                            onChange={() => this.deletehandleChange({index})}
                                            inputProps={{ 'aria-label': 'primary checkbox' }}
                                            color="primary"
                                            data-index={index}
                                        />
                                    </div>
                                    <div className="generate-suggest">
                                        <Checkbox
                                            className="generateChecked"
                                            checked={suggestion.generateChecked}
                                            onChange={() => this.generatehandleChange({index})}
                                            inputProps={{ 'aria-label': 'primary checkbox' }}
                                            color="primary"
                                            data-index={index}
                                        />
                                    </div>
                                </div>
                            )) : <div className="suggest_detail_no"></div>}
                            
                        </div>
                        <div className="footer">
                            <Button fullWidth id="editbtnButton" className={this.editBtnClassName()}  disabled={_.isEqual(this.state.suggestionList, this.state.suggestionChangeBefore)} onClick={() => this.editSuggestion()}>{this.props.intl.formatMessage({ id: "batch_edit" })}</Button>
                            <Button fullWidth id="goBackButton" className="button backbtn" onClick={() => this.goBack()}>{this.props.intl.formatMessage({ id: "go_back" })}</Button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withSnackbar(withRouter(injectIntl(Suggestion)), SNACKBAR_OPTIONS);
